export default __webpack_public_path__ + "static/media/discordimage.3dda400d.png";